"use strict";

var _slicedToArray = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base58_1 = require("./libs/base58");

var Base64 = require("base64-js");

var utils_1 = require("./libs/utils");

var Long = require("long");

var stringToUint8Array = function stringToUint8Array(str) {
  return Uint8Array.from(_toConsumableArray(unescape(encodeURIComponent(str))).map(function (c) {
    return c.charCodeAt(0);
  }));
};

exports.empty = Uint8Array.from([]);
exports.zero = Uint8Array.from([0]);
exports.one = Uint8Array.from([1]);

exports.BASE58_STRING = function (value) {
  return base58_1.default.decode(value);
};

exports.BASE64_STRING = function (value) {
  return Base64.toByteArray(value.replace('base64:', ''));
};

exports.STRING = function (value) {
  return value ? stringToUint8Array(value) : exports.empty;
};

exports.BYTE = function (value) {
  return Uint8Array.from([value]);
};

exports.BOOL = function (value) {
  return exports.BYTE(value == true ? 1 : 0);
};

exports.BYTES = function (value) {
  return Uint8Array.from(value);
};

exports.SHORT = function (value) {
  var s = Long.fromNumber(value, true);
  return Uint8Array.from(s.toBytesBE().slice(6));
};

exports.INT = function (value) {
  var i = Long.fromNumber(value, true);
  return Uint8Array.from(i.toBytesBE().slice(4));
};

exports.OPTION = function (s) {
  return function (value) {
    return value == null || typeof value == 'string' && value.length == 0 ? exports.zero : utils_1.concat(exports.one, s(value));
  };
};

exports.LEN = function (lenSerializer) {
  return function (valueSerializer) {
    return function (value) {
      var data = valueSerializer(value);
      var len = lenSerializer(data.length);
      return utils_1.concat(len, data);
    };
  };
};

exports.COUNT = function (countSerializer) {
  return function (itemSerializer) {
    return function (items) {
      var data = utils_1.concat.apply(utils_1, _toConsumableArray(items.map(function (x) {
        return itemSerializer(x);
      })));
      var len = countSerializer(items.length);
      return utils_1.concat(len, data);
    };
  };
};

exports.LONG = function (value) {
  var l;

  if (typeof value === 'number') {
    if (value > Math.pow(2, 53) - 1) {
      throw new Error("".concat(value, " is too big to be precisely represented as js number. Use string instead"));
    }

    l = Long.fromNumber(value);
  } else {
    l = Long.fromString(value.toString());
  }

  return Uint8Array.from(l.toBytesBE());
};

exports.SCRIPT = function (script) {
  return exports.OPTION(exports.LEN(exports.SHORT)(exports.BASE64_STRING))(script ? script.slice(7) : null);
};

exports.ALIAS = function (val) {
  var _val$split = val.split(':'),
      _val$split2 = _slicedToArray(_val$split, 3),
      _ = _val$split2[0],
      byte = _val$split2[1],
      alias = _val$split2[2];

  if (!byte || byte.length !== 1) throw new Error('Invalid network byte in alias');
  if (!alias || alias.length === 0) throw new Error('Invalid alias body');
  return utils_1.concat([2], [byte.charCodeAt(0)], exports.LEN(exports.SHORT)(exports.STRING)(alias));
};

exports.ADDRESS_OR_ALIAS = function (val) {
  return val.startsWith('alias') ? exports.ALIAS(val) : exports.BASE58_STRING(val);
};